import React, { useEffect, useState, useMemo, useCallback } from 'react'
import Form from '../../components/Form'
import { useForm } from 'react-hook-form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'
import Select from '../../components/Inputs/Select'
// import Datepicker from '../../components/Inputs/Datepicker'
import Switch from '../../components/Inputs/Switch'
import Button from '../../components/General/Button'
import Table from '../../components/Display/Table'
import InputNumber from '../../components/Inputs/InputNumber'
import { ColumnItemWrapper } from '../../components/General/ColumnItemWrapper'
import { IoMdAdd } from 'react-icons/io'
import { dateToDB, formatPipe, getDenomination } from '../../utils/utils'
import FloatingMenu from '../../components/Display/FloatingMenu'
import { HiDotsVertical } from 'react-icons/hi'
import { ColumnsTable, Components } from 'safe'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import range from 'lodash/range'
import { getMonth, getYear } from 'date-fns'

const server = process.env.REACT_APP_SERVER_URL
const NewEmployeeForm: React.FC<IEmployeeForm> = ({
  onCancel,
  onSubmit,
  type,
  selectedEmployee,
  onShowModal,
}) => {
  const currencies = useSelector((state: RootState) => state.curr.currencies)
  

  const form = useForm({
    defaultValues: {
      isActive: true,
      ...selectedEmployee,
      document: {
        documentType: selectedEmployee?.document.split('-')[0],
        document: selectedEmployee?.document.split('-')[1],
      },
      birthDate: (() => {
        let date = new Date()
        date.setMonth(date.getMonth() - 3)
        return date
      })(),
      amountBenefit: 0,
      descriptionBenefit: '',
      descriptionDeduction: '',
      amountDeduction: 0,
      baseSalary: +selectedEmployee?.baseSalary || 0,
    },
  })

  const [menuVisibleBenefits, setMenuVisibleBenefits] = useState<null | number>(
    null
  )

  const [menuVisibleDeductiions, setMenuVisibleDeductions] = useState<
    null | number
  >(null)

  const [benefitLoading, setBenefitLoading] = useState<boolean>(false)

  const [deductionLoading, setDeductionLoading] = useState<boolean>(false)

  const salaryFrecuencyOptions: Components.SelectOption[] = [
    {
      value: 'MONTHLY',
      text: 'Mensual',
    },
    {
      value: 'WEEKLY',
      text: 'Semanal',
    },
    {
      value: 'BIWEEKLY',
      text: 'Quincenal',
    },
  ]

  const docs: Components.SelectOption[] = [
    {
      value: 'V',
      text: 'V',
    },
    {
      value: 'J',
      text: 'J',
    },
    {
      value: 'E',
      text: 'E',
    },
    {
      value: 'P',
      text: 'P',
    },
    {
      value: 'G',
      text: 'G',
    },
    {
      value: 'C',
      text: 'C',
    },
  ]

  const banksOptions: Components.SelectOption[] = [
    {
      value: '0102',
      text: 'Banco de Venezuela',
    },
    {
      value: '0191',
      text: 'Banco Nacional de Credito',
    },
    {
      value: '0108',
      text: 'Banco Provincial',
    },
    {
      value: '0114',
      text: 'Bancaribe',
    },
    {
      value: '0115',
      text: 'Banco Exterior',
    },
    {
      value: '0163',
      text: 'Banco del Tesoro',
    },
    {
      value: '0134',
      text: 'Banesco',
    },
    {
      value: '0138',
      text: 'Banco Plaza',
    },
    {
      value: '0174',
      text: 'Banplus',
    },
    {
      value: '0169',
      text: 'Mi Banco',
    },
    {
      value: '0157',
      text: 'DEL SUR BU',
    },
    {
      value: '0168',
      text: 'Bancrecer',
    },
    {
      value: '0171',
      text: 'Banco Activo',
    },
    {
      value: '0151',
      text: 'BFC',
    },
    {
      value: '0172',
      text: 'Bancamiga',
    },
    {
      value: '0105',
      text: 'Mercantil',
    },
    {
      value: '0151',
      text: 'BFC',
    },
    {
      value: '0177',
      text: 'BANFANB',
    },
    {
      value: '0175',
      text: 'Bicentenario',
    },
    {
      value: '0137',
      text: 'SOFITASA',
    },
    {
      value: '0166',
      text: 'Agricola',
    },
    {
      value: '0128',
      text: 'Caroni',
    },
    {
      value: '0156',
      text: '100% Banco',
    },
    {
      value: '0104',
      text: 'Venezolano de Credito',
    },
  ]

  const columnsBenefits: ColumnsTable[] = [
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <p className="text-xs text-primary-900 dark:text-white font-medium">
          {`${getDenomination(form?.watch('currencyId'))} ${formatPipe(
            record?.amount
          )}`}
        </p>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any) => {
        return (
          <ColumnItemWrapper floatingMenu>
            <FloatingMenu
              visible={menuVisibleBenefits === (type === 'NEW' ? record?.idx : id)}
              onClose={() => {
                setMenuVisibleBenefits(-1)
              }}
              options={(() => {
                const onDeleteRow = async () => {
                  if (record?.id) {
                    setBenefitLoading(true)
                    await axios.delete(
                      `${server}/employee/benefit?id=${record?.id}`
                    )
                    setBenefits((prevState) =>
                      prevState.filter((v) => v?.id !== record?.id)
                    )
                    setBenefitLoading(false)
                  } else {
                    setBenefits((prevState) =>
                      prevState.filter((v, idx) => idx !== record?.idx)
                    )
                  }
                }

                if (type === 'NEW') {
                  return {
                    onDelete: onDeleteRow,
                  }
                }

                return {
                  onEdit: async () => {
                    onShowModal(record)
                  },
                  onDelete: onDeleteRow,
                }
              })()}
            >
              <HiDotsVertical
                className="cursor-pointer dark:text-white text-primaryGray-400"
                onClick={() => {
                  setMenuVisibleBenefits(id || record?.idx)
                }}
              />
            </FloatingMenu>
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const columnsDeductions: ColumnsTable[] = [
    {
      title: 'Descripción',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Monto',
      dataIndex: 'amount',
      key: 'amount',
      render: (id: number, record: any) => (
        <p className="text-xs text-primary-900 dark:text-white font-medium">
          {`${getDenomination(form?.watch('currencyId'))} ${formatPipe(
            record?.amount
          )}`}
        </p>
      ),
    },
    {
      title: '',
      dataIndex: 'id',
      align: 'right',
      width: 50,
      key: 'actions',
      render: (id: number, record: any) => {
        return (
          <ColumnItemWrapper floatingMenu>
            <FloatingMenu
              visible={menuVisibleDeductiions === (type === 'NEW' ? record?.idx : id)}
              onClose={() => {
                setMenuVisibleDeductions(-1)
              }}
              options={(() => {
                const onDeleteRow = async () => {
                  if (record?.id) {
                    setDeductionLoading(true)
                    await axios.delete(
                      `${server}/employee/deduction?id=${record?.id}`
                    )
                    setDeductions((prevState) =>
                      prevState.filter((v) => v?.id !== record?.id)
                    )
                    setDeductionLoading(false)
                  } else {
                    setDeductions((prevState) =>
                      prevState.filter((v, idx) => idx !== record?.idx)
                    )
                  }
                }

                if (type === 'NEW') {
                  return {
                    onDelete: onDeleteRow,
                  }
                }
                return {
                  onEdit: async () => {
                    onShowModal(record)
                  },
                  onDelete: onDeleteRow,
                }
              })()}
            >
              <HiDotsVertical
                className="cursor-pointer dark:text-white text-primaryGray-400"
                onClick={() => {
                  setMenuVisibleDeductions(id || record?.idx)
                }}
              />
            </FloatingMenu>
          </ColumnItemWrapper>
        )
      },
    },
  ]

  const [benefits, setBenefits] = useState<any[]>(
    selectedEmployee?.benefits?.map((v, idx) => ({
      ...v,
      idx,
      state: 'BENEFIT',
    })) || []
  )

  const [deductions, setDeductions] = useState<any[]>(
    selectedEmployee?.deductions?.map((v, idx) => ({
      ...v,
      idx,
      state: 'DEDUCTION',
    })) || []
  )

  useEffect(() => {
    setBenefits(
      selectedEmployee?.benefits?.map((v, idx) => ({
        ...v,
        idx,
        state: 'BENEFIT',
      })) || []
    )
    setDeductions(
      selectedEmployee?.deductions?.map((v, idx) => ({
        ...v,
        idx,
        state: 'DEDUCTION',
      })) || []
    )
  }, [selectedEmployee])

  const [currentBenefit, setCurrentBenefit] = useState<any | null>(null)

  const [currentDeduction, setCurrentDeduction] = useState<any | null>(null)

  const [birthDate, setBirthDate] = useState<Date | null>(type === "NEW" ? new Date() : selectedEmployee.birthDate)

  const [hireDate, setHireDate] = useState<Date | null>(type === "NEW" ? new Date() : selectedEmployee.hireDate)

  const years = range(1950, getYear(new Date()) + 1, 1)
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ]

  const monthFormatter = {
    January: 'Enero',
    February: 'Febrero',
    March: 'Marzo',
    April: 'Abril',
    May: 'Mayo',
    June: 'Junio',
    July: 'Julio',
    August: 'Agosto',
    September: 'Septiembre',
    October: 'Octubre',
    November: 'Noviembre',
    December: 'Diciembre',
  }

  const getDoc = () => {
    return docs.find(
      (doc) => doc?.value === selectedEmployee?.document?.split('-')[0]
    )
  }

  const getBankOption = () => {
    return banksOptions.find(
      (doc) => doc?.value === selectedEmployee?.bankCode?.split('-')[0]
    )
  }

  const getFrecuencyOption = () => {
    return salaryFrecuencyOptions.find(
      (v) => v?.value === selectedEmployee?.salaryFreq
    )
  }

  /**Se deja logica por si acaso */
  // const getCurrentBirthDayDate = () => {
  //   const [year, month, day] = selectedEmployee?.birthDate?.split('-')
  //   let date = new Date(+year, +month, +day)
  //   date.setMonth(date.getMonth() - 1)
  //   return date.toLocaleDateString('en-GB')
  // }

  // const getCurrentHireDate = () => {
  //   const [year, month, day] = selectedEmployee?.hireDate?.split('-')
  //   let date = new Date(+year, +month, +day)
  //   date.setMonth(date.getMonth() - 1)
  //   return date.toLocaleDateString('en-GB')
  // }

  const getCurrency = () => {
    let currency = currencies.find(
      (currency) => currency.id === selectedEmployee?.currencyId
    )
    return {
      value: currency?.id,
      text: currency?.name,
    }
  }

  const [selectedCurrency, setSelectedCurrency] = useState<string | null>(null)

  const renderMask = useCallback(() => {
    if (selectedCurrency === '1') {
      return (
        <CurrencyInput
          label="Salario Base"
          addDecimals={true}
          mask={`$. num`}
        />
      )
    }
    if (selectedCurrency === '2') {
      return (
        <CurrencyInput
          label="Salario Base"
          addDecimals={true}
          mask={`Bs. num`}
        />
      )
    }
    if (selectedCurrency === '3') {
      return (
        <CurrencyInput
          label="Salario Base"
          addDecimals={true}
          mask={`€. num`}
        />
      )
    }
    if (selectedCurrency === '4') {
      return (
        <CurrencyInput
          label="Salario Base"
          addDecimals={true}
          mask={`COP. num`}
        />
      )
    }
  }, [selectedCurrency])

  const formatDate = useCallback(
    (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    [birthDate, hireDate]
  )

  const onSubmitForm = (values: any) => {
    const {
      document,
      amountBenefit,
      amountDeduction,
      descriptionBenefit,
      descriptionDeduction,
      ...rest
    } = values

    if (!birthDate) {
      form?.setError('birthDate', { message: 'Fecha requerida' })
      return
    }

    onSubmit({
      ...rest,
      benefits,
      deductions,
      document: `${document?.documentType}-${document?.document}`,
      birthDate: formatDate(birthDate),
      hireDate: formatDate(hireDate),
      baseSalary: formatPipe(values?.baseSalary, true) + '',
    })
  }

  return (
    <>
      <Form
        classes="gap-x-5"
        form={form}
        onSubmit={(values) => {
          onSubmitForm(values)
        }}
      >
        <h2 className="col-span-12 mb-2 text-primary-900 font-bold">
          {type === 'EDIT' ? 'Editar empleado' : 'Añadir empleado'}
        </h2>

        <FormItem
          name="name"
          classes="xl:col-span-6 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <InputText label="Nombre" />
        </FormItem>

        <FormItem
          name="document.documentType"
          defaultValue={type === 'NEW' ? docs[0] : getDoc()}
          rules={{ required: 'Es necesario el campo' }}
          classes="xl:col-span-2 col-span-3"
        >
          <Select
            options={docs}
            /** Por si se desea realizar alguna logica cuando se seleccione el valor */
            // setSelectedHelper={async (v) => {
            //   setTypeDocumentSelected(v)

            // }}
            label="Tipo"
          />
        </FormItem>

        <FormItem
          name="document.document"
          classes="xl:col-span-4 col-span-9"
          rules={{
            required: 'Es necesario el documento',
            pattern: { value: /^\d+$/, message: 'Documento inválido' },
            minLength: {
              value: 6,
              message: 'El documento debe de poseer al menos 6 caracteres.',
            },
          }}
        >
          <InputText isUpperValue={false} label="Documento" maxLength={10} />
        </FormItem>

        <FormItem
          name="phone"
          classes="xl:col-span-6 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <InputText label="Número telefónico" />
        </FormItem>

        <FormItem
          name="birthDate"
          classes="xl:col-span-6 col-span-12"
        >
          <label
            className="text-primary-900 text-xs dark:text-white mt-1 font-medium"
            style={{ display: 'block' }}
          >
            Fecha de nacimiento
          </label>

          <DatePicker
            wrapperClassName="w-full"
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 10,
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {/* <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button> */}
                <select
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value as any)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <select
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {monthFormatter[option]}
                    </option>
                  ))}
                </select>

                {/* <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button> */}
              </div>
            )}
            selected={birthDate}
            onChange={(date) => {
              if (date) {
                form?.setValue('birthDate', date)
                setBirthDate(date)
              }
            }}
          />
        </FormItem>

        <FormItem
          name="email"
          classes="xl:col-span-6 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <InputText label="Correo electrónico" />
        </FormItem>

        <FormItem
          name="address"
          classes="xl:col-span-6 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <InputText label="Dirección" />
        </FormItem>

        <FormItem
          name="currencyId"
          classes="xl:col-span-6 col-span-12"
          defaultValue={
            type === 'NEW'
              ? {
                  value: currencies[0].id,
                  text: currencies[0].name,
                }
              : getCurrency()
          }
        >
          <Select
            options={currencies.map((currency) => ({
              value: currency.id,
              text: currency.name,
            }))}
            label="Moneda"
            onChange={(v) => {
              setSelectedCurrency(v?.value)
            }}
            // setSelectedHelper={setBan}
          />
        </FormItem>

        <FormItem
          name="baseSalary"
          classes="xl:col-span-6 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          {/* <InputText label="Salario Base" /> */}
          {/* <CurrencyInput label='Salario Base' addDecimals={true} mask={"Bs. num"} /> */}
          {renderMask()}
        </FormItem>

        <FormItem
          name="jobPosition"
          classes="xl:col-span-6 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <InputText label="Cargo" />
        </FormItem>

        <FormItem
          name="hireDate"
          classes="xl:col-span-6 col-span-12"
        >
          <label
            className="text-primary-900 text-xs dark:text-white mt-1 font-medium"
            style={{ display: 'block' }}
          >
            Fecha de contratación
          </label>

          <DatePicker
            wrapperClassName="w-full"
            renderCustomHeader={({
              date,
              changeYear,
              changeMonth,
              decreaseMonth,
              increaseMonth,
              prevMonthButtonDisabled,
              nextMonthButtonDisabled,
            }) => (
              <div
                style={{
                  margin: 10,
                  display: 'flex',
                  justifyContent: 'center',
                }}
              >
                {/* <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button> */}
                <select
                  value={getYear(date)}
                  onChange={({ target: { value } }) => changeYear(value as any)}
                >
                  {years.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>

                <select
                  value={months[getMonth(date)]}
                  onChange={({ target: { value } }) =>
                    changeMonth(months.indexOf(value))
                  }
                >
                  {months.map((option) => (
                    <option key={option} value={option}>
                      {monthFormatter[option]}
                    </option>
                  ))}
                </select>

                {/* <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
            {">"}
          </button> */}
              </div>
            )}
            selected={hireDate}
            onChange={(date) => {
              if (date) {
                form?.setValue('hireDate', date)
                setHireDate(date)
              }
            }}
          />
        </FormItem>

        <FormItem
          name="salaryFreq"
          classes="xl:col-span-6 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
          defaultValue={
            type === 'NEW' ? salaryFrecuencyOptions[0] : getFrecuencyOption()
          }
        >
          {/* <InputText label='Frecuencia'  /> */}
          <Select label="Frecuencia" options={salaryFrecuencyOptions} />
        </FormItem>

        <FormItem
          name="bankCode"
          classes="col-span-6"
          rules={{ required: 'Es necesario el banco' }}
          defaultValue={type === 'NEW' ? banksOptions[0] : getBankOption()}
        >
          <Select
            options={banksOptions}
            label="Bancos"
            setSelectedHelper={(v) => {}}
          />
        </FormItem>

        <FormItem
          name="bankAccountNumber"
          classes="xl:col-span-6 col-span-12"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <InputText label="Número de cuenta" />
        </FormItem>

        <FormItem
          name="isActive"
          classes="xl:col-span-6 col-span-12 mt-3"
          rules={{ required: 'Es necesario un nombre' }}
        >
          <Switch label="Empleado activo" forForm={true} />
        </FormItem>

        <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 my-5"></div>

        <h3 className="col-span-12 mb-2 text-primary-900 font-bold">
          Beneficios
        </h3>

        <div className="col-span-12">
          <Table
            showPagination={false}
            data={benefits}
            columns={columnsBenefits}
            setPageSelected={(page) => {}}
            loading={benefitLoading}
          />
        </div>

        <FormItem name="descriptionBenefit" classes="xl:col-span-7">
          <InputText
            label="Descripción"
            innerProps={{
              onChange: (e) => {
                setCurrentBenefit((prevState) => ({
                  ...prevState,
                  description: e.target.value,
                }))
              },
            }}
          />
        </FormItem>

        <FormItem name="amountBenefit" classes="xl:col-span-4">
          <InputNumber
            label="Monto"
            onChange={(v) => {
              setCurrentBenefit((prevState) => ({
                ...prevState,
                amount: v,
              }))
            }}
          />
        </FormItem>

        <div
          className="col-span-1 mt-6 w-8 h-8 flex justify-center items-center"
          style={{ backgroundColor: '#1A47AA', borderRadius: 5 }}
        >
          <button
            className="border-none p-0"
            onClick={async () => {
              if (type === 'EDIT') {
                setBenefitLoading(true)
                let body = {
                  employeeId: selectedEmployee?.id,
                  benefits: [
                    {
                      description: currentBenefit?.description,
                      amount: currentBenefit?.amount,
                    },
                  ],
                }
                let response = await axios.post(
                  `${server}/employee/benefit`,
                  body
                )
                setBenefits((prevState: any) => [
                  ...prevState,
                  {
                    ...currentBenefit,
                    state: 'BENEFIT',
                    idx: benefits?.length,
                    id: response?.data?.benefits[0]?.id,
                  },
                ])
                setBenefitLoading(false)
              } else {
                setBenefits((prevState: any) => [
                  ...prevState,
                  {
                    ...currentBenefit,
                    state: 'BENEFIT',
                    idx: benefits?.length,
                  },
                ])
              }

              form.setValue('descriptionBenefit', '')
              form.setValue('amountBenefit', '0')
            }}
            type="button"
          >
            <IoMdAdd size={30} color="white" />
          </button>
        </div>

        <div className="h-px dark:bg-primaryGray-600 bg-primaryGray-700 col-span-12 my-5"></div>

        <h3 className="col-span-12 mb-2 text-primary-900 font-bold">
          Deducción
        </h3>

        <div className="col-span-12">
          <Table
            showPagination={false}
            data={deductions}
            columns={columnsDeductions}
            setPageSelected={(page) => {}}
            loading={deductionLoading}
          />
        </div>

        <FormItem name="descriptionDeduction" classes="xl:col-span-7">
          <InputText
            label="Descripción"
            innerProps={{
              onChange: (e) => {
                setCurrentDeduction((prevState) => ({
                  ...prevState,
                  description: e.target.value,
                }))
              },
            }}
          />
        </FormItem>

        <FormItem name="amountDeduction" classes="xl:col-span-4">
          <InputNumber
            label="Monto"
            onChange={(v) => {
              setCurrentDeduction((prevState) => ({
                ...prevState,
                amount: v,
              }))
            }}
          />
        </FormItem>

        <div
          className="col-span-1 mt-6 w-8 h-8 flex justify-center items-center"
          style={{ backgroundColor: '#1A47AA', borderRadius: 5 }}
        >
          <button
            className="border-none p-0"
            onClick={async () => {
              if (type === 'EDIT') {
                setDeductionLoading(true)
                let body = {
                  employeeId: selectedEmployee?.id,
                  deductions: [
                    {
                      description: currentDeduction?.description,
                      amount: currentDeduction?.amount,
                    },
                  ],
                }
                let response = await axios.post(
                  `${server}/employee/deduction`,
                  body
                )
                setDeductions((prevState: any) => [
                  ...prevState,
                  {
                    ...currentDeduction,
                    state: 'DEDUCTION',
                    idx: deductions?.length,
                    id: response?.data?.deductions[0]?.id,
                  },
                ])
                setDeductionLoading(false)
              } else {
                setDeductions((prevState: any) => [
                  ...prevState,
                  {
                    ...currentDeduction,
                    state: 'DEDUCTION',
                    idx: deductions?.length,
                  },
                ])
              }

              form.setValue('descriptionDeduction', '')
              form.setValue('amountDeduction', '0')
            }}
            type="button"
          >
            <IoMdAdd size={30} color="white" />
          </button>
        </div>

        <div className="col-span-12 h-full flex flex-row mt-5">
          <div className="w-1/2 mr-5 pl-1">
            <Button
              onClick={() => {
                onCancel()
              }}
              type="outline"
              classes="w-full"
            >
              Cancelar
            </Button>
          </div>
          <div className="w-1/2 pr-1">
            <Button
              type="primary"
              loading={false}
              classes="w-full"
              htmlType="submit"
            >
              {'Guardar cambios'}
            </Button>
          </div>
        </div>
      </Form>
    </>
  )
}

interface IEmployeeForm {
  onSubmit: (values: any) => void
  onCancel: () => void
  type: 'EDIT' | 'NEW'
  selectedEmployee: any
  onShowModal: (selectedValue: any) => void
}

export default NewEmployeeForm
